import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  institutionsRankingsParticipantsSelectors,
  institutionsRankingsParticipantsThunks,
} from '@ucheba/store/institutions/rankings/detail/participants'
import { useRouter } from 'next/router'
import { institutionsRankingsSelectors } from '@ucheba/store/institutions/rankings'
import { mainSubRating, rankingQuery } from './constants'
import { IUseInstitutionsRankingsLogic } from './types'

export const useInstitutionsRankingsLogic: IUseInstitutionsRankingsLogic = (
  id,
  subRatings
) => {
  const [isShowParticipants, toggleShowAllParticipants] = useState(false)
  const [selectedSubRating, setSelectedSubRating] = useState(mainSubRating)
  const [isDropdownOpen, toggleDropdownOpen] = useState(false)
  const rankingParticipants = useSelector(
    institutionsRankingsParticipantsSelectors.byId(selectedSubRating.id || id)
  )
  const ranking = useSelector(institutionsRankingsSelectors.byId(id))
  const { query } = useRouter()

  const dispatch = useDispatch()

  const selectSubRating = useCallback(
    async (subRating) => {
      const subID = subRating.id === 0 ? {} : { subId: subRating.id }

      await dispatch(
        institutionsRankingsParticipantsThunks.fetch({
          data: { id, ...subID },
        })
      )

      setSelectedSubRating(subRating)
      toggleDropdownOpen(true)
      setTimeout(() => toggleDropdownOpen(false))
    },
    [dispatch, id]
  )

  /** Проставляем сабрейтинг у конкретного рейтинга по квери-параметрам */
  useEffect(() => {
    const rankingId = window.location.hash

    if (rankingId && query[rankingQuery.subRanking]) {
      const rankingIdByQuery = Number(rankingId?.split('-').pop())

      if (ranking?.rating.id === rankingIdByQuery) {
        const selectedSubRatingByQuery = subRatings.find(
          (subRating) => subRating.id === Number(query[rankingQuery.subRanking])
        )

        selectSubRating(selectedSubRatingByQuery)
      }
    }
  }, [ranking?.rating.id]) // Остальное ставить не нужно

  const dropdownItems = useMemo(() => {
    return [mainSubRating, ...subRatings]
  }, [subRatings])

  return {
    dropdownItems,
    selectedSubRating,
    selectSubRating,
    isDropdownOpen,
    rankingParticipants,
    isShowParticipants,
    toggleShowAllParticipants,
  }
}
